import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";

export const HOST_MANAGEMENT_APIS = {
  getCancelEventsTicketsListing: (params: any) => getRequest("/event/cancellation-tickets", params),
  approveCancelEventTicket: (ticketId: number, body: any) => patchRequest(`/event/cancellation-tickets/${ticketId}/approve`, body),
  postChatTicketMessages: (ticketId: number, body: any) => postRequest(`/event/cancellation-tickets/${ticketId}/chat`, body),
  getChatTicketMessages: (ticketId: number, params?: any) => getRequest(`/event/cancellation-tickets/${ticketId}/chat`, params),



};
